class ConditionVariantSelector extends VariantSelector {
  constructor() {
    super();
    this.property = 'condition';

    this.value = false;
    this.displayValue = false;
    this.unavailableLabel = this.getAttribute('unavailable-label');
    this.formId = this.getAttribute('form-id');
    this.variantFontFamily = this.getAttribute('variant-font-family');

    this.options = [];
    this.wrapper = this.querySelector('.product-condition-selector');
    this.tooltip = this.querySelector('.product-condition-selector__tooltip');
    this.label = this.querySelector('.product-condition-selector__label');
  }

  setValue(value){
    super.setValue(value);
    const selected = this.querySelector(`[name="${this.property}-option"][value="${value}"`);
    selected.checked = true;
    this.updateLabel();
  }

  render(){
    const options = window.variants.getVariantData(this.property);
    let markup = '';

    options.forEach((option, index) => {
      const selectorID = `selector-${this.property}-${index}`;

      markup += `<input id="${selectorID}" type="radio" form="${this.formId}" name="${this.property}-option" value="${option.value}" class="p-small ${!option.enabled ? 'disabled hidden' : ''}" selected="false" aria-disabled="${!option.enabled}">
      <label for="${selectorID}" class="${this.variantFontFamily}">
        <span class="">${option.label}</span>
        <span class="visually-hidden ${!option.enabled ? 'hidden': ''}">${this.unavailableLabel}</span>
        <svg><line x1="0" y1="98%" x2="100%" y2="2%"></line></svg>
      </label>`;
    });

    this.wrapper.insertAdjacentHTML('beforeend', markup);

    this.wrapper.classList.toggle('hidden', options.length === 0);

    /* Set options within inputs to enable event listener attachment to each child. */
    this.options = this.querySelectorAll('input[type="radio"]');

    this.options.forEach((element) => {
      element.addEventListener('change', this.onValueChanged.bind(this));
    });
  }
  
  updateOptions(event){

    if (event.detail.property != this.property){
      const options = window.variants.getVariantData(this.property);
      const hasSizeProperty = !!window.variants.properties.find(element => element === 'size');

      // Size needs to be selected or '*' (all props updates) to show any conditions.
      const isSizeRequirementMet = window.variants.hasVariantOptionSelected('size') ||
        event.detail.property == '*' ||
        !hasSizeProperty;

      if (isSizeRequirementMet) this.tooltip.classList.remove('hidden');

      options.forEach((option, index) => {
        const input = this.querySelector(`input[value="${option.value}"]`);
        const label = input.nextElementSibling;
        const unavailableLabel = label.querySelector('span.visually-hidden');

        if (option.enabled && isSizeRequirementMet){
          unavailableLabel.innerHTML = '';
          input.classList.remove('disabled');
          input.classList.remove('hidden');
          label.classList.remove('hidden');
        } else {
          unavailableLabel.innerHTML = this.unavailableLabel;
          input.classList.add('disabled');
          input.classList.add('hidden');
          label.classList.add('hidden');
        }
        input.setAttribute('aria-disabled', !option.enabled);
      });

      // Set a default condition if nothing is selected.
      let conditionSelected = this.querySelector(`[name="${this.property}-option"]:checked:not(.disabled.hidden)`);

      if (!conditionSelected) {
        // Grab the first available condition.
        conditionSelected  = this.querySelector(`[name="${this.property}-option"]:not(.disabled.hidden)`);
        if (conditionSelected) {
          this.classList.remove('hidden');
          conditionSelected.checked = true;
          conditionSelected.dispatchEvent(new Event('change'));
        }
      }

      if (!conditionSelected){
        this.classList.add('hidden');
        this.classList.remove('block');
      } else {
        this.classList.remove('hidden');
        this.classList.add('block');
      }
    }
  }

  updateSelected(event) {

    if (event.detail.property == this.property){
      const selected = this.querySelector(`[name="${this.property}-option"][value="${event.detail.code}"]`);
      if (selected){
        selected.checked = true;
        this.updateLabel();
      }
    }
  }
  
  updateLabel() {
    const selected = this.querySelector(`[name="${this.property}-option"]:checked`);
    this.tooltip.classList.remove('hidden');
    this.displayValue = this.querySelector(`label[for="${selected.id}"] span:first-child`).textContent;
    this.tooltip.dataset.acsbTooltip = `${this.property}: ${this.displayValue}`;    
    this.label.innerHTML = this.displayValue;
  }

  onValueChanged(event){
    const selected = this.querySelector(`[name="${this.property}-option"]:checked`);
    this.setValue(selected.value);
    window.variants.setVariantOption(this.property, this.value);
  }
}

customElements.define('condition-variant-selector', ConditionVariantSelector);
